import ApiManager from '../api/crud-manager';
import ResultPagination from './result-pagination';
import utils from '../utils';
import jsonToView from '../api/json-to-view';

const { lang } = document.documentElement;

class ContentSearch {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="ContentSearch"]'),
      parameters: {
        page: '1',
        items: '24',
        culture: lang.length ? lang.toLowerCase() : 'nl'
      },
      ...options
    };
    this.apiManager = new ApiManager();
    this.resultPagination = new ResultPagination();
  }

  setPagination(response) {
    this.resultPagination.render('ContentSearch', response);
  }

  getSearchResults(searchQuery) {
    const { parameters } = this.config;

    // set parameters
    parameters.q = searchQuery;
    parameters.type = 'html';
    const parameterLink = utils.buildApiParameters(parameters);

    const url = `/api/v2/content/findpage${parameterLink}`;
    return this.apiManager
      .get(url)
      .then(data => {
        const regex = /<[^>]+>|&nbsp;|&amp;/g;
        const newItems = data.items.filter(item => {
          const htmlString = item.contentData.replaceAll(regex, '');
          return htmlString.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
        });
        const newData = { ...data };
        // eslint-disable-next-line no-shadow
        newData.items = newItems.map(data => {
          // eslint-disable-next-line no-param-reassign
          data.contentData = data.contentData.replaceAll(regex, ' ');
          return data;
        });

        return newData;
      })
      .catch(error => {
        throw new Error(error);
      });
  }

  renderSearchResults(searchQuery) {
    const { module } = this.config;
    const element = module.querySelector('[data-child-module="ContentSearchResultList"]');

    element.classList.add('is-loading');

    this.getSearchResults(searchQuery).then(searchResponse => {
      const { items, totalItems } = searchResponse;

      // set view data & settings
      const templateView = 'contentSearchResults';
      const viewData = {
        results: items,
        resultsCount: totalItems,
        searchQuery
      };

      jsonToView(viewData, templateView)
        .then(html => {
          // append html to element
          element.classList.remove('is-loading');
          element.innerHTML = html;

          // render pagination
          this.setPagination(searchResponse);
        })
        .catch(error => {
          element.innerHTML =
            element.dataset.errorMessage ||
            'An error has occurred, please try again later or contact us.';
          element.classList.remove('is-loading');
          element.classList.add('is-error');
          throw new Error(error);
        });
    });
  }

  init() {
    const { module } = this.config;

    if (!module) {
      return;
    }

    const searchInput = module.querySelector('input[name="q"]');
    if (searchInput && searchInput.value && searchInput.value.length >= 2) {
      this.renderSearchResults(searchInput.value);
    }
  }
}

export default ContentSearch;
